/**
 * Test IDs for QA automation.
 */
export const testIds = {
  contactFormTitle: "contact-form-title",
  contactFormFirstName: "contact-form-first-name",
  contactFormLastName: "contact-form-last-name",
  contactFormEmailAddress: "contact-form-email-address",
  contactFormExtensionNumber: "contact-form-extension-number",
  contactFormUrlAddress: "contact-form-url-address",
  contactFormFaxNumber: "contact-form-fax-number",
  contactFormIncludeInInvoicing: "contact-form-include-in-invoicing",
  contactFormIncludeInDocumentSending: "contact-form-include-in-document-sending",
} as const;
